// Default translation catalog. Admins can override individual strings via the
// `/copy` page in admin; overrides are merged on top of this base catalog at
// runtime by the loader in apps/web and apps/admin.
//
// Keys are dot-namespaced: `nav.signup`, `landing.hero.title`, etc.
//
// IMPORTANT: keep both `th` and `en` in lockstep. CI lint asserts equal key sets.

import type { TranslationCatalog } from "./types.ts";

export const baseCatalog: TranslationCatalog = {
  th: {
    "nav.signup": "สมัครสมาชิก",
    "nav.login": "เข้าสู่ระบบ",
    "nav.logout": "ออกจากระบบ",
    "nav.home": "หน้าหลัก",
    "nav.all_series": "ซีรีส์ทั้งหมด",
    "nav.new": "มาใหม่",
    "nav.series": "ซีรีส์ทั้งหมด",
    "nav.about": "เกี่ยวกับเรา",
    "nav.search": "ค้นหา",
    "nav.account": "บัญชีของฉัน",
    "nav.my_list": "รายการของฉัน",

    "landing.hero.title": "พื้นที่ของความรู้สึก ที่คุณจะหยุดไม่ได้",
    "landing.hero.subtitle": "ซีรีส์วายแนวใหม่ สั้นเร้าใจตอนละ 2 นาที ดูฟรี 3 ตอนแรก แล้วปลดล็อกได้เลย",
    "landing.hero.cta_play": "เริ่มดูเลย",
    "landing.hero.cta_trailer": "ดูตัวอย่าง",
    "landing.hero.followers": "{count} คนติดตาม",

    "landing.trending.title": "ซีรีส์มาแรง",
    "landing.trending.see_all": "ดูทั้งหมด",

    "card.free_first_n": "ดูฟรี {count} ตอนแรก",
    "card.locked": "ปลดล็อก",

    "landing.pillars.free_eps": "ดูฟรี 3 ตอนแรก",
    "landing.pillars.free_eps.sub": "เริ่มต้นง่าย ไม่ต้องสมัคร",
    "landing.pillars.unlock_per_ep": "ปลดล็อกตอนต่อตอน",
    "landing.pillars.unlock_per_ep.sub": "จ่ายเท่าที่คุณดู",
    "landing.pillars.bundle": "เหมาทั้งซีรีส์",
    "landing.pillars.bundle.sub": "คุ้มกว่าเมื่อดูยาว",

    "landing.featured.watch_trailer": "ดูตัวอย่าง",
    "landing.featured.unlock_ep": "ปลดล็อก {price} บาท",
    "landing.featured.episodes_label": "ตอนทั้งหมด {count} ตอน",
    "landing.featured.runtime_label": "ตอนละประมาณ {minutes} นาที",

    "trust.pay_once": "จ่ายครั้งเดียวต่อตอน",
    "trust.safe": "ปลอดภัย 100%",
    "trust.any_device": "ดูได้ทุกอุปกรณ์",
    "trust.no_ads": "ไม่มีโฆษณาคั่น",

    "newsletter.title": "ให้พวกเรารู้ก่อนใคร",
    "newsletter.subtitle": "ติดตามอีเมลรู้ก่อนซีรีส์ใหม่ออก",
    "newsletter.placeholder": "อีเมลของคุณ",
    "newsletter.cta": "สมัครรับข่าวสาร",
    "newsletter.success": "สมัครสำเร็จ ขอบคุณ!",
    "newsletter.error": "เกิดข้อผิดพลาด ลองใหม่อีกครั้ง",

    "footer.about": "เกี่ยวกับ",
    "footer.support": "ช่วยเหลือ",
    "footer.terms": "ข้อกำหนด",
    "footer.privacy": "นโยบายความเป็นส่วนตัว",
    "footer.cookies": "นโยบายคุกกี้",
    "footer.contact": "ติดต่อเรา",
    "footer.copyright": "© {year} Bloom. สงวนลิขสิทธิ์",
    "footer.tagline": "ซีรีส์วาย สั้นเร้าใจ ตอนละ 2 นาที ดูฟรี 3 ตอนแรก แล้วปลดล็อกตอนถัดไป",
    "footer.menu_heading": "เมนู",
    "footer.help_heading": "ช่วยเหลือ",
    "footer.account_heading": "บัญชีของฉัน",
    "footer.legal_heading": "กฎหมายและนโยบาย",
    "footer.follow_heading": "ติดตามเรา",
    "footer.faq": "คำถามที่พบบ่อย",
    "footer.contact_us": "ติดต่อเรา",
    "footer.report_problem": "แจ้งปัญหา",
    "footer.purchase_history": "ประวัติการซื้อ",
    "footer.terms_of_service": "ข้อตกลงการใช้งาน",
    "footer.refund_policy": "นโยบายการคืนเงิน",

    "auth.email": "อีเมล",
    "auth.password": "รหัสผ่าน",
    "auth.continue": "ดำเนินการต่อ",
    "auth.continue_with_google": "เข้าสู่ระบบด้วย Google",
    "auth.dont_have_account": "ยังไม่มีบัญชี?",
    "auth.have_account": "มีบัญชีอยู่แล้ว?",
    "auth.forgot_password": "ลืมรหัสผ่าน?",
    "auth.signup": "สร้างบัญชี",
    "auth.login": "เข้าสู่ระบบ",
    "auth.verify_email": "ยืนยันอีเมลของคุณ",
    "auth.verify_email_sent": "เราส่งลิงก์ยืนยันไปที่ {email} แล้ว",
    "auth.reset_password": "ตั้งรหัสผ่านใหม่",
    "auth.2fa_title": "ยืนยันตัวตน 2 ขั้นตอน",

    "series.episodes": "ตอน",
    "series.free_first_n": "ดูฟรี {count} ตอนแรก",
    "series.unlock_bundle": "เหมาทั้งซีรีส์ {price} บาท",
    "series.ep_locked": "ปลดล็อก",
    "series.ep_unlocked": "ดูได้",
    "series.ep_free": "ฟรี",
    "series.runtime_short": "{minutes} นาที",
    "series.rating": "เรตติ้ง {score} ({count})",

    "player.next_in": "ตอนถัดไปใน {seconds}",
    "player.next_episode": "ตอนถัดไป",
    "player.previous_episode": "ตอนก่อนหน้า",
    "player.unlock_to_continue": "ปลดล็อกตอนถัดไปเพื่อดูต่อ",
    "player.subtitles_off": "ปิดคำบรรยาย",
    "player.subtitles": "คำบรรยาย",
    "player.fullscreen": "เต็มจอ",
    "player.pause": "หยุดชั่วคราว",
    "player.play": "เล่น",
    "player.cap_exceeded": "อุปกรณ์อื่นกำลังดูอยู่ รีเฟรชเพื่อรับสิทธิ์มาดูที่นี่",

    "checkout.title": "ปลดล็อกการดู",
    "checkout.episode_subtitle": "ตอน {ep} — {seriesTitle}",
    "checkout.bundle_subtitle": "ทั้งซีรีส์ — {seriesTitle}",
    "checkout.amount": "ราคา {amount} บาท",
    "checkout.pay_promptpay": "จ่ายด้วย PromptPay",
    "checkout.pay_card": "จ่ายด้วยบัตร",
    "checkout.success_title": "ชำระเงินสำเร็จ",
    "checkout.success_subtitle": "พร้อมเริ่มดู!",
    "checkout.failed": "ชำระเงินไม่สำเร็จ",
    "checkout.expired": "ลิงก์หมดอายุ ลองอีกครั้ง",

    "settings.locale": "ภาษา",
    "settings.locale.th": "ไทย",
    "settings.locale.en": "English",
    "settings.subtitles": "คำบรรยาย",
    "settings.subtitles.default": "อัตโนมัติ",

    "errors.not_found": "ไม่พบหน้าที่คุณต้องการ",
    "errors.server": "เกิดข้อผิดพลาด ลองใหม่อีกครั้ง",
    "errors.unauthorized": "ต้องเข้าสู่ระบบก่อน",
    "errors.forbidden": "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
    "errors.404.title": "หาไม่เจอจริงๆ",
    "errors.404.subtitle": "หน้าที่คุณตามหาอาจหายไป หรือไม่เคยมีอยู่เลย",
    "errors.404.cta": "กลับหน้าแรก",
    "errors.500.title": "ดูเหมือนจะมีปัญหา",
    "errors.500.subtitle": "เราได้รับแจ้งแล้ว ลองรีเฟรชอีกครั้งในไม่ช้า",
    "errors.500.cta": "ลองอีกครั้ง",
    "errors.maintenance.title": "ปรับปรุงระบบสักครู่",
    "errors.maintenance.subtitle": "Bloom กำลังบ่มซีรีส์ใหม่ๆ ให้พร้อมเสิร์ฟ กลับมาในอีกไม่กี่นาที",

    "ratings.heading": "รู้สึกยังไงกับตอนนี้?",
    "ratings.series_heading": "ชอบซีรีส์นี้ไหม?",
    "ratings.dislike": "ไม่ชอบ",
    "ratings.like": "ชอบ",
    "ratings.super": "ชอบมาก",
    "ratings.clear": "ล้างการให้คะแนน",
    "ratings.thanks": "ขอบคุณที่บอก!",
    "ratings.display.percent_liked": "{percent}% ชอบ",
    "ratings.display.hidden_gem": "อัญมณีที่ซ่อนอยู่ — ชอบมาก {count} คน",
    "ratings.display.too_few": "ยังเก็บคะแนนไม่พอ",

    // ── About page ──────────────────────────────────────────────────────
    "about.eyebrow": "เกี่ยวกับ Bloom",
    "about.hero.title": "บ้านของซีรีส์วายแนวตั้ง",
    "about.hero.tagline": "ดูง่าย เร็ว เร้าใจ ตอนละ 2 นาที",
    "about.hero.body":
      "Bloom คือพื้นที่ของซีรีส์วายไทยแนวสั้น สำหรับคนที่อยากจะรู้สึกอะไรบางอย่างในเวลา 2 นาที เราเล่าเรื่องในรูปแบบแนวตั้ง 9:16 ออกแบบมาเพื่อให้คุณดูได้ทุกที่ ทุกเวลา ระหว่างรอรถไฟฟ้า หรือก่อนนอน",
    "about.why.title": "ทำไมต้องสั้น?",
    "about.why.body":
      "เพราะชีวิตเร่งรีบ และเรื่องราวที่ดีไม่จำเป็นต้องยาว ตอนละ 2 นาทีให้คุณได้ดื่มด่ำเรื่องราวที่ลงตัวกับการเดินทาง 3 ตอนแรกฟรี เพื่อให้คุณลองชิม และปลดล็อกต่อไปเมื่อใจคุณพร้อม",
    "about.why.point_1.title": "2 นาทีต่อตอน",
    "about.why.point_1.body": "ความยาวที่กลืนได้ในเวลาคอยรถ",
    "about.why.point_2.title": "เรื่องที่ลงตัวกับชีวิตคุณ",
    "about.why.point_2.body": "เริ่ม-จบเป็นตอนๆ ไม่ต้องคุยยาว",
    "about.why.point_3.title": "ฟรี 3 ตอนแรก",
    "about.why.point_3.body": "ลองก่อน ค่อยปลดล็อก",
    "about.bangkok.title": "ทำในกรุงเทพ",
    "about.bangkok.body":
      "ทุกซีรีส์บนแพลตฟอร์ม Bloom สร้างขึ้นโดยทีมงานและผู้สร้างไทย เราภูมิใจที่ได้เป็นพื้นที่ให้นักเขียน ผู้กำกับ และนักแสดงรุ่นใหม่ของไทยได้เล่าเรื่องของพวกเขา ในแบบที่เป็นพวกเขาเอง",
    "about.pillars.title": "สิ่งที่ทำให้ Bloom เป็น Bloom",
    "about.pillars.free": "ดูฟรี 3 ตอนแรก",
    "about.pillars.free.sub": "เริ่มต้นง่าย ไม่ต้องสมัคร",
    "about.pillars.unlock": "ปลดล็อกต่อตอน",
    "about.pillars.unlock.sub": "จ่ายเฉพาะตอนที่อยากดู",
    "about.pillars.bundle": "เหมาทั้งซีรีส์",
    "about.pillars.bundle.sub": "คุ้มกว่าเมื่อดูยาว",
    "about.pillars.anywhere": "ดูได้ทุกที่",
    "about.pillars.anywhere.sub": "บนเว็บ ใช้ได้ทุกอุปกรณ์",
    "about.contact.title": "อยากคุยกับเรา?",
    "about.contact.body": "ส่งข้อความหาเรา ถามคำถาม หรือบอกเล่าสิ่งที่คุณคิด",
    "about.contact.cta_contact": "ติดต่อเรา",
    "about.contact.cta_faq": "คำถามที่พบบ่อย",

    // ── FAQ page ────────────────────────────────────────────────────────
    "faq.eyebrow": "ช่วยเหลือ",
    "faq.title": "คำถามที่พบบ่อย",
    "faq.subtitle": "หาคำตอบเร็วๆ หรือพิมพ์เพื่อค้นหา",
    "faq.search_placeholder": "ค้นหาคำถาม...",
    "faq.empty": "ไม่พบคำถามที่ตรงกัน ลองคำอื่นหรือ ติดต่อเรา",
    "faq.contact_cta": "ยังไม่เจอคำตอบ?",
    "faq.contact_cta.body": "ส่งคำถามมาที่ทีมงาน เราตอบกลับภายใน 1 วันทำการ",

    "faq.section.account": "บัญชีและการสมัคร",
    "faq.section.payments": "การชำระเงิน",
    "faq.section.watching": "การรับชม",
    "faq.section.content": "เนื้อหาและซีรีส์",
    "faq.section.privacy": "ความเป็นส่วนตัว",

    "faq.account.q1": "ฉันต้องสมัครบัญชีก่อนดูไหม?",
    "faq.account.a1":
      "ไม่ต้อง 3 ตอนแรกของทุกซีรีส์ดูได้ฟรีโดยไม่ต้องสมัคร แต่หากอยากดูตอนต่อไป คุณต้องสมัครบัญชีก่อนจึงจะปลดล็อกได้",
    "faq.account.q2": "ใช้ Google เข้าสู่ระบบได้ไหม?",
    "faq.account.a2": "ได้ Bloom รองรับการเข้าสู่ระบบด้วย Google เพื่อความสะดวก ไม่ต้องจำรหัสผ่านอีกหนึ่งชุด",
    "faq.account.q3": "ลืมรหัสผ่านต้องทำยังไง?",
    "faq.account.a3": "กดลิงก์ ลืมรหัสผ่าน ที่หน้าเข้าสู่ระบบ เราจะส่งลิงก์รีเซ็ตไปทางอีเมล ลิงก์มีอายุ 30 นาที",
    "faq.account.q4": "ลบบัญชีของฉันได้ไหม?",
    "faq.account.a4": "ได้ ไปที่ บัญชีของฉัน > ความเป็นส่วนตัว แล้วเลือก ลบบัญชี เราจะลบข้อมูลของคุณภายใน 30 วัน",
    "faq.account.q5": "ใช้บัญชีเดียวบนหลายอุปกรณ์ได้ไหม?",
    "faq.account.a5": "ได้ คุณสามารถเข้าสู่ระบบบัญชีเดียวกันบนหลายอุปกรณ์ แต่เล่นได้ทีละหนึ่งสตรีมต่อบัญชี",

    "faq.payments.q1": "ทำไมราคาขั้นต่ำคือ 18 บาท?",
    "faq.payments.a1":
      "เพราะเป็นยอดต่ำสุดที่ Stripe ยอมรับสำหรับสกุลเงินบาท เราจึงแนะนำให้ซื้อแบบรวมตอนหรือเหมาทั้งซีรีส์เพื่อความคุ้มค่า",
    "faq.payments.q2": "รับชำระเงินด้วยวิธีไหนบ้าง?",
    "faq.payments.a2": "รับบัตรเครดิต/เดบิต (Visa, Mastercard) และ PromptPay ทุกธนาคารของไทย",
    "faq.payments.q3": "ขอคืนเงินได้ไหม?",
    "faq.payments.a3":
      "หากตอนหรือซีรีส์ที่ซื้อมีปัญหาทางเทคนิคและคุณยังไม่ได้ดู สามารถขอคืนเงินได้ ดูรายละเอียดที่ นโยบายการคืนเงิน",
    "faq.payments.q4": "ออกใบเสร็จ/ใบกำกับภาษีให้ไหม?",
    "faq.payments.a4": "ทุกการชำระเงินจะมีใบเสร็จส่งไปทางอีเมลโดยอัตโนมัติ พร้อม PDF สำหรับดาวน์โหลด",
    "faq.payments.q5": "ราคาในเว็บรวม VAT แล้วใช่ไหม?",
    "faq.payments.a5": "ใช่ ทุกราคาที่แสดงบน Bloom เป็นราคาสุดท้ายที่รวม VAT 7% แล้ว",

    "faq.watching.q1": "ดูบนทีวีได้ไหม?",
    "faq.watching.a1": "ขณะนี้ Bloom ใช้งานได้บนเว็บเบราว์เซอร์เท่านั้น เรากำลังพัฒนา Chromecast เร็วๆ นี้",
    "faq.watching.q2": "คำบรรยายมีกี่ภาษา?",
    "faq.watching.a2":
      "ทุกตอนมีคำบรรยายภาษาไทยและอังกฤษ คุณสามารถสลับได้ในโปรแกรมเล่น โดยไม่กระทบภาษาของหน้าเว็บ",
    "faq.watching.q3": "ดูออฟไลน์ได้ไหม?",
    "faq.watching.a3": "ยังไม่สามารถดาวน์โหลดเพื่อดูออฟไลน์ได้ ฟีเจอร์นี้อยู่ในแผนพัฒนา",
    "faq.watching.q4": "วิดีโอกระตุก/โหลดช้าทำยังไงดี?",
    "faq.watching.a4":
      "ลองรีเฟรชหน้าเว็บ ตรวจสอบสัญญาณอินเทอร์เน็ต หรือเปลี่ยนคุณภาพวิดีโอเป็นต่ำลงในโปรแกรมเล่น หากยังไม่หาย แจ้งปัญหาให้เราได้",
    "faq.watching.q5": "ตอนที่ปลดล็อกแล้วดูได้กี่ครั้ง?",
    "faq.watching.a5": "ดูได้ไม่จำกัดจำนวนครั้ง ตราบใดที่บัญชีของคุณยังคงใช้งานอยู่",

    "faq.content.q1": "Bloom เป็นซีรีส์แนวไหน?",
    "faq.content.a1": "Bloom เน้นซีรีส์วาย (Boys' Love) ไทย ในรูปแบบสั้นแนวตั้ง 9:16 ตอนละประมาณ 2 นาที",
    "faq.content.q2": "มีซีรีส์ใหม่ทุกเมื่อ?",
    "faq.content.a2": "เราออกซีรีส์ใหม่ทุกสัปดาห์ สมัครรับจดหมายข่าวเพื่อรู้ก่อนใครว่ามีอะไรจะออก",
    "faq.content.q3": "ใครเป็นผู้สร้างซีรีส์บน Bloom?",
    "faq.content.a3": "ทีมงาน ผู้กำกับ และนักแสดงไทยทั้งหมด Bloom ทำงานกับสตูดิโออิสระและผู้สร้างหน้าใหม่",
    "faq.content.q4": "ซีรีส์ทุกเรื่องเป็นภาษาไทยใช่ไหม?",
    "faq.content.a4": "ใช่ เสียงต้นฉบับเป็นภาษาไทย พร้อมคำบรรยายภาษาไทยและอังกฤษในทุกตอน",
    "faq.content.q5": "อายุเรตติ้งของซีรีส์เป็นแบบไหน?",
    "faq.content.a5": "ส่วนใหญ่เป็น 13+ และ 18+ ดูเรตติ้งของแต่ละซีรีส์ได้ที่หน้ารายละเอียดก่อนเริ่มดู",

    "faq.privacy.q1": "Bloom เก็บข้อมูลอะไรของฉันบ้าง?",
    "faq.privacy.a1":
      "เราเก็บอีเมล ความก้าวหน้าการดู และประวัติการซื้อ เพื่อให้บริการเท่านั้น ดูรายละเอียดได้ใน นโยบายความเป็นส่วนตัว",
    "faq.privacy.q2": "ขายข้อมูลให้ฝ่ายที่สามไหม?",
    "faq.privacy.a2": "ไม่ Bloom ไม่ขายข้อมูลของคุณกับใคร เราใช้ข้อมูลเพื่อบริการของเราเท่านั้น",
    "faq.privacy.q3": "ใช้คุกกี้แบบไหน?",
    "faq.privacy.a3": "เฉพาะคุกกี้ที่จำเป็นต่อการทำงาน (เช่น การเข้าสู่ระบบ การตั้งค่าภาษา) ดูเพิ่มเติมที่ นโยบายคุกกี้",
    "faq.privacy.q4": "ขอดู/ขอลบข้อมูลของฉันได้ไหม?",
    "faq.privacy.a4": "ได้ ทั้งสองอย่าง ไปที่ บัญชีของฉัน > ความเป็นส่วนตัว เพื่อขอสำเนาหรือขอลบข้อมูล",
    "faq.privacy.q5": "เด็กอายุต่ำกว่า 13 ปีใช้ Bloom ได้ไหม?",
    "faq.privacy.a5": "ไม่ Bloom กำหนดอายุขั้นต่ำที่ 13 ปี หากต่ำกว่านี้ต้องอยู่ภายใต้การดูแลของผู้ปกครอง",

    // ── Contact + Support ───────────────────────────────────────────────
    "contact.eyebrow": "ติดต่อเรา",
    "contact.title": "เราพร้อมรับฟัง",
    "contact.subtitle": "ส่งข้อความหาเรา ทีมงานจะตอบกลับภายใน 1 วันทำการ",
    "contact.panel.tagline": "พื้นที่ของความรู้สึก ที่คุณจะหยุดไม่ได้",
    "contact.panel.reply_window": "เราตอบกลับภายใน 1 วันทำการ",
    "contact.panel.or_email": "หรือส่งอีเมลโดยตรงที่",
    "contact.form.name": "ชื่อ",
    "contact.form.email": "อีเมล",
    "contact.form.subject": "หัวข้อ",
    "contact.form.message": "ข้อความ",
    "contact.form.category": "หมวดหมู่ (ไม่บังคับ)",
    "contact.form.category_placeholder": "เลือกหมวดหมู่",
    "contact.form.submit": "ส่งข้อความ",
    "contact.form.sending": "กำลังส่ง...",
    "contact.success.title": "ส่งข้อความเรียบร้อย",
    "contact.success.body": "เราได้รับข้อความของคุณแล้ว ทีมงานจะตอบกลับทางอีเมลภายใน 1 วันทำการ",
    "contact.success.ticket": "หมายเลขอ้างอิง",
    "contact.success.new_message": "ส่งข้อความอีกครั้ง",
    "contact.error": "เกิดข้อผิดพลาด ลองส่งใหม่อีกครั้ง",

    "support.eyebrow": "แจ้งปัญหา",
    "support.title": "บอกเราว่าอะไรไม่เป็นอย่างที่ควร",
    "support.subtitle": "ช่วยเราแก้ปัญหาให้คุณได้เร็วขึ้น โดยบอกหมวดหมู่และรายละเอียดที่พบ",
    "support.panel.tagline": "ขอบคุณที่ช่วยให้ Bloom ดีขึ้น",
    "support.panel.reply_window": "เราตรวจสอบทุกรายงานภายใน 1 วันทำการ",
    "support.form.category_required": "หมวดหมู่ปัญหา",
    "support.form.category_placeholder": "เลือกหมวดหมู่",
    "support.form.submit": "ส่งรายงาน",
    "support.category.playback": "ปัญหาการเล่นวิดีโอ",
    "support.category.subtitles": "ปัญหาคำบรรยาย",
    "support.category.payments": "ปัญหาการชำระเงิน",
    "support.category.account": "ปัญหาบัญชี",
    "support.category.other": "อื่นๆ",

    // ── Series index (catalog page) ─────────────────────────────────────
    "series_index.subtitle": "สำรวจซีรีส์ทั้งหมดของเรา — ดูฟรี 3 ตอนแรกทุกเรื่อง",
    "series_index.sort_label": "เรียงโดย",
    "series_index.chip.all": "ทั้งหมด",
    "series_index.empty.title": "ไม่พบซีรีส์",
    "series_index.empty.description": "ลองเปลี่ยนหมวดหมู่หรือเคลียร์ตัวกรองดูนะ",
    "series_index.clear_filters": "เคลียร์ตัวกรอง",
    "series_index.sort.featured": "แนะนำ",
    "series_index.sort.newest": "ใหม่ล่าสุด",
    "series_index.sort.popular": "ยอดนิยม",
    "series_index.sort.top_rated": "เรตติ้งสูงสุด",

    // ── Series detail page ──────────────────────────────────────────────
    "series.episode_count": "{count} ตอน",
    "series.first_n_free_short": "{count} ตอนแรกฟรี",
    "series.cta.watch_first_free": "ดูตอนแรกฟรี",
    "series.cta.watchlist_add": "เพิ่มในรายการ",
    "series.cta.watchlist_in": "อยู่ในรายการแล้ว",
    "series.free_promo_full": "ดูฟรี {free} ตอนแรก · ปลดล็อกเหมาทั้งซีรีส์ {price} บาท",
    "series.synopsis": "เรื่องย่อ",
    "series.cast": "นักแสดง",
    "series.more_from_category": "ซีรีส์ที่คล้ายกัน",
    "series.trailer": "ตัวอย่าง",
    "series.rating.hidden_gem_short": "ดาวรุ่ง",
    "series.rating.percent_liked_short": "{percent}% ชอบ",
    "series.unlock_sheet.title": "ปลดล็อกเพื่อดู",
    "series.unlock_sheet.signin_to_unlock": "เข้าสู่ระบบเพื่อปลดล็อก ฿{price}",
    "series.unlock_sheet.use_wallet": "ใช้กระเป๋าเงิน · ฿{price} (คงเหลือ ฿{balance})",
    "series.unlock_sheet.topup_and_unlock": "เติม ฿{short} แล้วปลดล็อก ฿{price}",
    "series.unlock_sheet.bundle_wallet": "เหมาทั้งซีรีส์ด้วยกระเป๋าเงิน — ฿{price}",
    "series.unlock_sheet.or_pay_directly": "หรือจ่ายโดยตรง",
    "series.unlock_sheet.pack_of_two": "แพ็ก 2 ตอน — ฿{price} (Stripe)",

    // ── Account shell + tabs ────────────────────────────────────────────
    "account.tab.profile": "โปรไฟล์",
    "account.tab.wallet": "กระเป๋าเงิน",
    "account.tab.purchases": "การซื้อ",
    "account.tab.watch_history": "ประวัติการดู",
    "account.tab.devices": "อุปกรณ์",
    "account.tab.security": "ความปลอดภัย",
    "account.tab.notifications": "การแจ้งเตือน",
    "account.tab.language": "ภาษา",
    "account.tab.data_privacy": "ข้อมูลและความเป็นส่วนตัว",

    // ── Account · Profile ──────────────────────────────────────────────
    "account.profile.heading": "ข้อมูลบัญชี",
    "account.profile.subheading": "ข้อมูลบัญชีของคุณบน Bloom",
    "account.profile.field.name": "ชื่อ",
    "account.profile.field.email": "อีเมล",
    "account.profile.field.locale": "ภาษา",
    "account.profile.field.role": "บทบาท",

    // ── Account · Purchases ────────────────────────────────────────────
    "account.purchases.empty.title": "ยังไม่มีการซื้อ",
    "account.purchases.empty.description": "ปลดล็อกตอนแรกของคุณเพื่อเริ่มต้น",
    "account.purchases.empty.cta": "เลือกซีรีส์",
    "account.purchases.kind.bundle": "เหมาทั้งซีรีส์",
    "account.purchases.kind.pack": "แพ็ก {count} ตอน",
    "account.purchases.status.paid": "ชำระแล้ว",
    "account.purchases.method.card": "บัตรเครดิต",
    "account.purchases.receipt.label": "ใบเสร็จ",
    "account.purchases.receipt.opening": "กำลังเปิด…",
    "account.purchases.receipt.unavailable": "ไม่สามารถเปิดใบเสร็จได้ในขณะนี้",

    // ── Account · Language ─────────────────────────────────────────────
    "account.language.heading": "ภาษาที่แสดง",
    "account.language.subheading": "เปลี่ยนภาษาของอินเทอร์เฟซ ทุกหน้ารวมถึงคำบรรยายจะเปลี่ยนตาม",
    "account.language.tip": "เคล็ดลับ: คุณก็เปลี่ยนได้จากแถบด้านบนของทุกหน้า",

    // ── Account · Wallet ───────────────────────────────────────────────
    "account.wallet.balance_label": "ยอดคงเหลือในกระเป๋า",
    "account.wallet.totals": "เติมแล้ว ฿{credited} · ใช้แล้ว ฿{spent}",
    "account.wallet.topup.heading": "เติมเงิน",
    "account.wallet.topup.subheading": "ขั้นต่ำ ฿10 · จ่ายด้วยบัตรหรือ PromptPay",
    "account.wallet.topup.custom_placeholder": "จำนวนอื่น (10–5000)",
    "account.wallet.topup.cta": "เติม",
    "account.wallet.tx.heading": "ประวัติธุรกรรม",
    "account.wallet.tx.empty": "ยังไม่มีธุรกรรม",
    "account.wallet.tx.balance_label": "คงเหลือ",
    "account.wallet.tx.kind.topup": "เติมเงิน",
    "account.wallet.tx.kind.promo": "โปรโมชั่น",
    "account.wallet.tx.kind.refund": "คืนเงิน",
    "account.wallet.tx.kind.unlock_episode": "ปลดล็อกตอน",
    "account.wallet.tx.kind.unlock_bundle": "ปลดล็อกซีรีส์",
    "account.wallet.tx.kind.adjustment": "ปรับยอด",

    // ── Account · Watch history ────────────────────────────────────────
    "account.history.empty.title": "ยังไม่มีประวัติการดู",
    "account.history.empty.description": "เลือกตอนแรกของซีรีส์เพื่อเริ่มดู",
    "account.history.empty.cta": "เลือกซีรีส์",
    "account.history.continue_heading": "ดูต่อ",
    "account.history.all_heading": "ประวัติทั้งหมด",
    "account.history.clear_link": "ล้างประวัติ",
    "account.history.confirm.title": "ล้างประวัติทั้งหมด?",
    "account.history.confirm.message":
      "การดำเนินการนี้ไม่สามารถย้อนกลับได้ — รายการ Continue watching จะหายไปทั้งหมด",
    "account.history.confirm.confirm": "ล้าง",
    "account.history.confirm.confirm_busy": "กำลังล้าง…",
    "account.history.confirm.cancel": "ยกเลิก",
    "account.history.status.completed": "ดูจบแล้ว",

    // ── Account · Devices ──────────────────────────────────────────────
    "account.devices.heading": "อุปกรณ์ที่กำลังใช้งาน",
    "account.devices.subheading": "ออกจากระบบของอุปกรณ์ใด ๆ ที่คุณไม่รู้จัก",
    "account.devices.signout_others": "ออกจากระบบของอุปกรณ์อื่นทั้งหมด",
    "account.devices.signout_others_busy": "กำลังออก…",
    "account.devices.this_device": "อุปกรณ์นี้",
    "account.devices.signout": "ออก",
    "account.devices.signout_busy": "กำลัง…",
    "account.devices.signout_current": "ออกจากระบบ",

    // ── Account · Security ─────────────────────────────────────────────
    "account.security.password.heading": "เปลี่ยนรหัสผ่าน",
    "account.security.password.subheading": "ตั้งรหัสผ่านใหม่ที่คาดเดายาก",
    "account.security.password.current": "รหัสผ่านปัจจุบัน",
    "account.security.password.new": "รหัสผ่านใหม่",
    "account.security.password.confirm": "ยืนยันรหัสผ่านใหม่",
    "account.security.password.too_short": "รหัสผ่านต้องยาวอย่างน้อย 8 ตัวอักษร",
    "account.security.password.mismatch": "รหัสผ่านไม่ตรงกัน",
    "account.security.password.updated": "เปลี่ยนรหัสผ่านเรียบร้อย",
    "account.security.password.save": "บันทึก",
    "account.security.password.saving": "กำลังบันทึก…",
    "account.security.2fa.heading": "การยืนยันสองขั้นตอน",
    "account.security.2fa.subheading": "ใช้แอปอย่าง Google Authenticator เพื่อเพิ่มรหัสยืนยันตอนเข้าสู่ระบบ",
    "account.security.2fa.status.enabled": "เปิดใช้งาน",
    "account.security.2fa.status.off": "ปิด",
    "account.security.2fa.confirm_label": "ยืนยันด้วยรหัสผ่าน",
    "account.security.2fa.enable": "เปิดใช้งาน",
    "account.security.2fa.enabling": "กำลัง…",
    "account.security.2fa.disable": "ปิด",
    "account.security.2fa.disabling": "กำลัง…",
    "account.security.2fa.setup_heading": "ขั้นตอนถัดไป: สแกน QR หรือคัดลอกรหัสด้วยมือ",
    "account.security.2fa.backup_codes": "รหัสสำรอง",
    "account.security.2fa.backup_codes_hint": "เก็บรหัสสำรองไว้ในที่ปลอดภัย — ใช้สำหรับกู้คืนเมื่อไม่มีแอปยืนยัน",

    // ── Account · Notifications ────────────────────────────────────────
    "account.notifications.marketing.title": "อีเมลโปรโมชั่น",
    "account.notifications.marketing.desc": "โปรโมชั่นและการเปิดตัวประเภทใหม่",
    "account.notifications.new_releases.title": "แจ้งเตือนตอนใหม่",
    "account.notifications.new_releases.desc": "แจ้งเตือนเมื่อซีรีส์ที่คุณติดตามปล่อยตอนใหม่",
    "account.notifications.newsletter.title": "จดหมายข่าวรายสัปดาห์",
    "account.notifications.newsletter.desc": "ซีรีส์แนะนำ บทสัมภาษณ์ และเบื้องหลัง",
    "account.notifications.saving": "กำลังบันทึก…",
    "account.notifications.saved": "บันทึกแล้ว",
    "account.notifications.auto_save_hint": "การเปลี่ยนแปลงจะบันทึกอัตโนมัติ",

    // ── Account · Data & privacy ───────────────────────────────────────
    "account.privacy.export.heading": "ส่งออกข้อมูลของฉัน",
    "account.privacy.export.subheading":
      "เราจะรวบรวมโปรไฟล์ ประวัติการดู และการซื้อทั้งหมด ส่งลิงก์ ZIP ทางอีเมลภายใน 24 ชั่วโมง",
    "account.privacy.export.queued": "เข้าคิวเรียบร้อย",
    "account.privacy.export.eta": "เราจะส่งอีเมลภายใน {hours} ชั่วโมง",
    "account.privacy.export.busy": "กำลังส่งคำขอ…",
    "account.privacy.export.cta": "ขอสำเนาข้อมูล",
    "account.privacy.delete.heading": "ลบบัญชีของฉัน",
    "account.privacy.delete.subheading":
      "บัญชีจะถูกระงับและลบถาวรภายใน 30 วัน คุณสามารถยกเลิกได้ภายในช่วงนั้นโดยติดต่อฝ่ายสนับสนุน",
    "account.privacy.delete.cta": "ลบบัญชี",
    "account.privacy.delete.confirm_title": "ยืนยันการลบบัญชี?",
    "account.privacy.delete.confirm_message":
      "พิมพ์อีเมล {email} เพื่อยืนยันการลบบัญชี — การดำเนินการนี้ไม่สามารถย้อนกลับได้",
    "account.privacy.delete.confirm": "ลบบัญชี",
    "account.privacy.delete.deleting": "กำลังลบ…",
    "account.privacy.delete.cancel": "ยกเลิก",

    // ── Legal page titles ──────────────────────────────────────────────
    "legal.terms.title": "ข้อกำหนดการใช้บริการ",
    "legal.privacy.title": "นโยบายความเป็นส่วนตัว",
    "legal.cookies.title": "นโยบายคุกกี้",
    "legal.refund.title": "นโยบายการคืนเงิน",
    "legal.contact_prefix": "หากมีคำถามทางกฎหมาย ติดต่อ ",
  },
  en: {
    "nav.signup": "Sign up",
    "nav.login": "Log in",
    "nav.logout": "Log out",
    "nav.home": "Home",
    "nav.all_series": "All series",
    "nav.new": "New",
    "nav.series": "All series",
    "nav.about": "About",
    "nav.search": "Search",
    "nav.account": "My account",
    "nav.my_list": "My list",

    "landing.hero.title": "A place for feelings you can't put down.",
    "landing.hero.subtitle":
      "Short, intense BL drama. 2 minutes per episode. First 3 free, then unlock.",
    "landing.hero.cta_play": "Start watching",
    "landing.hero.cta_trailer": "Watch trailer",
    "landing.hero.followers": "{count} followers",

    "landing.trending.title": "Trending now",
    "landing.trending.see_all": "See all",

    "card.free_first_n": "First {count} episodes free",
    "card.locked": "Locked",

    "landing.pillars.free_eps": "First 3 episodes free",
    "landing.pillars.free_eps.sub": "No signup required to start",
    "landing.pillars.unlock_per_ep": "Unlock per episode",
    "landing.pillars.unlock_per_ep.sub": "Pay only for what you watch",
    "landing.pillars.bundle": "Whole-series bundle",
    "landing.pillars.bundle.sub": "Better value for binge-watchers",

    "landing.featured.watch_trailer": "Watch trailer",
    "landing.featured.unlock_ep": "Unlock for {price} THB",
    "landing.featured.episodes_label": "{count} episodes",
    "landing.featured.runtime_label": "~{minutes} min each",

    "trust.pay_once": "Pay once per episode",
    "trust.safe": "100% safe",
    "trust.any_device": "Any device",
    "trust.no_ads": "No mid-roll ads",

    "newsletter.title": "Be the first to know",
    "newsletter.subtitle": "Subscribe to hear about new series first.",
    "newsletter.placeholder": "Your email address",
    "newsletter.cta": "Subscribe",
    "newsletter.success": "Subscribed. Thank you!",
    "newsletter.error": "Something went wrong, please try again.",

    "footer.about": "About",
    "footer.support": "Support",
    "footer.terms": "Terms",
    "footer.privacy": "Privacy policy",
    "footer.cookies": "Cookie policy",
    "footer.contact": "Contact",
    "footer.copyright": "© {year} Bloom. All rights reserved.",
    "footer.tagline": "Short, intense BL drama. 2 minutes per episode. First 3 free, then unlock.",
    "footer.menu_heading": "Menu",
    "footer.help_heading": "Help",
    "footer.account_heading": "Account",
    "footer.legal_heading": "Legal",
    "footer.follow_heading": "Follow us",
    "footer.faq": "FAQ",
    "footer.contact_us": "Contact us",
    "footer.report_problem": "Report a problem",
    "footer.purchase_history": "Purchase history",
    "footer.terms_of_service": "Terms of service",
    "footer.refund_policy": "Refund policy",

    "auth.email": "Email",
    "auth.password": "Password",
    "auth.continue": "Continue",
    "auth.continue_with_google": "Continue with Google",
    "auth.dont_have_account": "Don't have an account?",
    "auth.have_account": "Already have an account?",
    "auth.forgot_password": "Forgot password?",
    "auth.signup": "Create account",
    "auth.login": "Log in",
    "auth.verify_email": "Verify your email",
    "auth.verify_email_sent": "We sent a verification link to {email}.",
    "auth.reset_password": "Set a new password",
    "auth.2fa_title": "Two-factor authentication",

    "series.episodes": "Episodes",
    "series.free_first_n": "First {count} episodes free",
    "series.unlock_bundle": "Unlock the bundle — {price} THB",
    "series.ep_locked": "Unlock",
    "series.ep_unlocked": "Watch",
    "series.ep_free": "Free",
    "series.runtime_short": "{minutes} min",
    "series.rating": "Rated {score} ({count})",

    "player.next_in": "Next in {seconds}",
    "player.next_episode": "Next episode",
    "player.previous_episode": "Previous episode",
    "player.unlock_to_continue": "Unlock the next episode to continue",
    "player.subtitles_off": "Subtitles off",
    "player.subtitles": "Subtitles",
    "player.fullscreen": "Fullscreen",
    "player.pause": "Pause",
    "player.play": "Play",
    "player.cap_exceeded": "Another device started watching. Refresh to take over.",

    "checkout.title": "Unlock to watch",
    "checkout.episode_subtitle": "Episode {ep} — {seriesTitle}",
    "checkout.bundle_subtitle": "Whole series — {seriesTitle}",
    "checkout.amount": "{amount} THB",
    "checkout.pay_promptpay": "Pay with PromptPay",
    "checkout.pay_card": "Pay with card",
    "checkout.success_title": "Payment successful",
    "checkout.success_subtitle": "Ready to watch.",
    "checkout.failed": "Payment failed",
    "checkout.expired": "Session expired — try again",

    "settings.locale": "Language",
    "settings.locale.th": "Thai",
    "settings.locale.en": "English",
    "settings.subtitles": "Subtitles",
    "settings.subtitles.default": "Auto",

    "errors.not_found": "Page not found",
    "errors.server": "Something went wrong",
    "errors.unauthorized": "Sign in to continue",
    "errors.forbidden": "You don't have access to this page",
    "errors.404.title": "Nothing here",
    "errors.404.subtitle": "The page you were looking for might have moved — or it never existed.",
    "errors.404.cta": "Back to home",
    "errors.500.title": "Something tripped",
    "errors.500.subtitle": "We've been pinged. Try again in a moment.",
    "errors.500.cta": "Try again",
    "errors.maintenance.title": "Bloom is briefly resting",
    "errors.maintenance.subtitle":
      "We're prepping new episodes behind the scenes. Back in a few minutes.",

    "ratings.heading": "How was that?",
    "ratings.series_heading": "How did you feel about this series?",
    "ratings.dislike": "Not for me",
    "ratings.like": "Liked it",
    "ratings.super": "Loved it",
    "ratings.clear": "Clear rating",
    "ratings.thanks": "Thanks for letting us know!",
    "ratings.display.percent_liked": "{percent}% Liked",
    "ratings.display.hidden_gem": "Hidden gem — {count} loved it",
    "ratings.display.too_few": "Not enough ratings yet",

    // ── About page ──────────────────────────────────────────────────────
    "about.eyebrow": "About Bloom",
    "about.hero.title": "A home for vertical Thai BL drama.",
    "about.hero.tagline": "Two minutes per episode. Built for the in-between moments.",
    "about.hero.body":
      "Bloom is a home for vertical Thai BL drama. We're built for people who want to feel something in two minutes — short, punchy episodes shot in 9:16 portrait, made to fit a train ride, a lunch break, or the moment right before sleep.",
    "about.why.title": "Why short-form?",
    "about.why.body":
      "Because life is busy, and good stories don't have to be long. Each episode is a self-contained ~2-minute beat — small enough to fit your commute, big enough to make you wait for the next one. The first 3 episodes of every series are free, so you can dive in without committing.",
    "about.why.point_1.title": "2 minutes per episode",
    "about.why.point_1.body": "Bite-sized arcs you can finish in a single subway stop",
    "about.why.point_2.title": "Story arcs that fit your day",
    "about.why.point_2.body": "Episodes start and end clean — no homework required",
    "about.why.point_3.title": "Free first 3 episodes",
    "about.why.point_3.body": "Try before you unlock the rest",
    "about.bangkok.title": "Made in Bangkok",
    "about.bangkok.body":
      "Every series on Bloom is created by Thai writers, directors, and cast. We're proud to be a stage for emerging Thai creators telling stories the way they want to tell them — in their voice, for their audience first.",
    "about.pillars.title": "What makes Bloom, Bloom",
    "about.pillars.free": "First 3 episodes free",
    "about.pillars.free.sub": "No signup required to start",
    "about.pillars.unlock": "Unlock per episode",
    "about.pillars.unlock.sub": "Pay only for what you watch",
    "about.pillars.bundle": "Whole-series bundle",
    "about.pillars.bundle.sub": "Better value for binge-watchers",
    "about.pillars.anywhere": "Watch anywhere",
    "about.pillars.anywhere.sub": "Web today, any device",
    "about.contact.title": "Want to talk?",
    "about.contact.body": "Send us a message, ask a question, or tell us what you think.",
    "about.contact.cta_contact": "Contact us",
    "about.contact.cta_faq": "Browse the FAQ",

    // ── FAQ page ────────────────────────────────────────────────────────
    "faq.eyebrow": "Help",
    "faq.title": "Frequently asked questions",
    "faq.subtitle": "Find quick answers, or search to narrow down.",
    "faq.search_placeholder": "Search questions...",
    "faq.empty": "No matching questions. Try another keyword or contact us.",
    "faq.contact_cta": "Still stuck?",
    "faq.contact_cta.body": "Send your question to the team — we reply within one business day.",

    "faq.section.account": "Account & signup",
    "faq.section.payments": "Payments",
    "faq.section.watching": "Watching",
    "faq.section.content": "Content & series",
    "faq.section.privacy": "Privacy",

    "faq.account.q1": "Do I need an account to watch?",
    "faq.account.a1":
      "No — the first 3 episodes of every series are free without an account. After that, you'll need to sign up to unlock more.",
    "faq.account.q2": "Can I sign in with Google?",
    "faq.account.a2":
      "Yes. Bloom supports Google sign-in so you don't have to remember another password.",
    "faq.account.q3": "What if I forget my password?",
    "faq.account.a3":
      "Tap Forgot password on the login screen. We'll email you a reset link valid for 30 minutes.",
    "faq.account.q4": "Can I delete my account?",
    "faq.account.a4":
      "Yes. Go to My account > Privacy and choose Delete account. We remove your data within 30 days.",
    "faq.account.q5": "Can I use one account on multiple devices?",
    "faq.account.a5":
      "Yes, sign in on any number of devices — but you can only play one stream at a time per account.",

    "faq.payments.q1": "Why is the minimum ฿18?",
    "faq.payments.a1":
      "That's Stripe's minimum charge for Thai Baht. Bundles and multi-episode packs bring the per-episode price down significantly.",
    "faq.payments.q2": "What payment methods do you accept?",
    "faq.payments.a2":
      "Credit and debit cards (Visa, Mastercard) and PromptPay from any Thai bank.",
    "faq.payments.q3": "Can I get a refund?",
    "faq.payments.a3":
      "If an episode or series you bought has a technical issue and you haven't watched it, you can request a refund — see our Refund policy.",
    "faq.payments.q4": "Do you provide receipts / tax invoices?",
    "faq.payments.a4":
      "Every payment triggers an email receipt automatically, plus a downloadable PDF invoice.",
    "faq.payments.q5": "Are prices on Bloom VAT-inclusive?",
    "faq.payments.a5":
      "Yes — every price shown on Bloom is the final amount, with 7% VAT included.",

    "faq.watching.q1": "Can I watch on a TV?",
    "faq.watching.a1":
      "Bloom currently runs in web browsers only. Chromecast support is on our near-term roadmap.",
    "faq.watching.q2": "What subtitle languages are available?",
    "faq.watching.a2":
      "Every episode ships with Thai and English subtitles. You can switch in the player — independently from the language of the rest of the site.",
    "faq.watching.q3": "Can I watch offline?",
    "faq.watching.a3": "Not yet — downloading for offline playback is a feature we're planning.",
    "faq.watching.q4": "Video keeps buffering — what should I do?",
    "faq.watching.a4":
      "Try refreshing the page, checking your connection, or lowering the video quality in the player. If it persists, send us a report.",
    "faq.watching.q5": "How many times can I rewatch an unlocked episode?",
    "faq.watching.a5": "As many times as you like, for as long as your account is active.",

    "faq.content.q1": "What kind of shows is Bloom?",
    "faq.content.a1":
      "Bloom focuses on Thai BL (Boys' Love) drama in short, vertical 9:16 form — about 2 minutes per episode.",
    "faq.content.q2": "How often are new series added?",
    "faq.content.a2":
      "We release new series every week. Subscribe to the newsletter to be the first to know.",
    "faq.content.q3": "Who makes the shows on Bloom?",
    "faq.content.a3":
      "All Thai crew, directors, and cast. Bloom works with independent studios and emerging creators.",
    "faq.content.q4": "Are all series in Thai?",
    "faq.content.a4":
      "Yes — original audio is Thai, with Thai and English subtitles on every episode.",
    "faq.content.q5": "What age ratings do the series carry?",
    "faq.content.a5":
      "Most are rated 13+ or 18+. You'll see the rating on each series detail page before you start watching.",

    "faq.privacy.q1": "What data does Bloom collect about me?",
    "faq.privacy.a1":
      "We store your email, watch progress, and purchase history — only what's needed to provide the service. See our Privacy policy for details.",
    "faq.privacy.q2": "Do you sell my data to third parties?",
    "faq.privacy.a2":
      "No. Bloom does not sell your data to anyone. We use it only to run our own service.",
    "faq.privacy.q3": "What cookies do you use?",
    "faq.privacy.a3":
      "Only the ones we need for the site to work (login, language preference). See our Cookie policy for more.",
    "faq.privacy.q4": "Can I request a copy of my data, or have it deleted?",
    "faq.privacy.a4": "Yes, both. Go to My account > Privacy to request an export or deletion.",
    "faq.privacy.q5": "Can someone under 13 use Bloom?",
    "faq.privacy.a5":
      "No. Bloom is intended for users 13 and over; under-13 use requires parental supervision.",

    // ── Contact + Support ───────────────────────────────────────────────
    "contact.eyebrow": "Contact",
    "contact.title": "We're here to listen",
    "contact.subtitle": "Send us a message — we usually reply within one business day.",
    "contact.panel.tagline": "A place for feelings you can't put down.",
    "contact.panel.reply_window": "We usually reply within one business day",
    "contact.panel.or_email": "Or email us directly at",
    "contact.form.name": "Name",
    "contact.form.email": "Email",
    "contact.form.subject": "Subject",
    "contact.form.message": "Message",
    "contact.form.category": "Category (optional)",
    "contact.form.category_placeholder": "Choose a category",
    "contact.form.submit": "Send message",
    "contact.form.sending": "Sending...",
    "contact.success.title": "Message received",
    "contact.success.body": "We got your message and we'll reply by email within one business day.",
    "contact.success.ticket": "Reference",
    "contact.success.new_message": "Send another message",
    "contact.error": "Something went wrong, please try again.",

    "support.eyebrow": "Report a problem",
    "support.title": "Tell us what's not working",
    "support.subtitle": "Help us fix it faster — pick a category and share what you saw.",
    "support.panel.tagline": "Thanks for helping us make Bloom better.",
    "support.panel.reply_window": "We review every report within one business day",
    "support.form.category_required": "Problem category",
    "support.form.category_placeholder": "Choose a category",
    "support.form.submit": "Submit report",
    "support.category.playback": "Playback issue",
    "support.category.subtitles": "Subtitles",
    "support.category.payments": "Payments",
    "support.category.account": "Account",
    "support.category.other": "Other",

    // ── Series index (catalog page) ─────────────────────────────────────
    "series_index.subtitle": "Browse every Bloom series — first 3 episodes free on every show.",
    "series_index.sort_label": "Sort by",
    "series_index.chip.all": "All",
    "series_index.empty.title": "No series match these filters",
    "series_index.empty.description": "Try a different category, or clear all filters.",
    "series_index.clear_filters": "Clear filters",
    "series_index.sort.featured": "Featured",
    "series_index.sort.newest": "Newest",
    "series_index.sort.popular": "Popular",
    "series_index.sort.top_rated": "Top rated",

    // ── Series detail page ──────────────────────────────────────────────
    "series.episode_count": "{count} episodes",
    "series.first_n_free_short": "First {count} free",
    "series.cta.watch_first_free": "Watch first episode free",
    "series.cta.watchlist_add": "Add to watchlist",
    "series.cta.watchlist_in": "In watchlist",
    "series.free_promo_full": "First {free} episodes free · Unlock the bundle for ฿{price}",
    "series.synopsis": "Synopsis",
    "series.cast": "Cast",
    "series.more_from_category": "More from this category",
    "series.trailer": "Trailer",
    "series.rating.hidden_gem_short": "Hidden gem",
    "series.rating.percent_liked_short": "{percent}% Liked",
    "series.unlock_sheet.title": "Unlock to watch",
    "series.unlock_sheet.signin_to_unlock": "Sign in to unlock — ฿{price}",
    "series.unlock_sheet.use_wallet": "Use wallet · ฿{price} (balance ฿{balance})",
    "series.unlock_sheet.topup_and_unlock": "Top up ฿{short} & unlock ฿{price}",
    "series.unlock_sheet.bundle_wallet": "Unlock whole series from wallet — ฿{price}",
    "series.unlock_sheet.or_pay_directly": "Or pay directly",
    "series.unlock_sheet.pack_of_two": "Pack of 2 — ฿{price} (Stripe)",

    // ── Account shell + tabs ────────────────────────────────────────────
    "account.tab.profile": "Profile",
    "account.tab.wallet": "Wallet",
    "account.tab.purchases": "Purchases",
    "account.tab.watch_history": "Watch history",
    "account.tab.devices": "Devices",
    "account.tab.security": "Security",
    "account.tab.notifications": "Notifications",
    "account.tab.language": "Language",
    "account.tab.data_privacy": "Data & privacy",

    // ── Account · Profile ──────────────────────────────────────────────
    "account.profile.heading": "Account info",
    "account.profile.subheading": "Your Bloom account at a glance.",
    "account.profile.field.name": "Name",
    "account.profile.field.email": "Email",
    "account.profile.field.locale": "Locale",
    "account.profile.field.role": "Role",

    // ── Account · Purchases ────────────────────────────────────────────
    "account.purchases.empty.title": "Nothing here yet",
    "account.purchases.empty.description": "Unlock your first episode to get started.",
    "account.purchases.empty.cta": "Browse series",
    "account.purchases.kind.bundle": "Whole series",
    "account.purchases.kind.pack": "{count}-episode pack",
    "account.purchases.status.paid": "Paid",
    "account.purchases.method.card": "Card",
    "account.purchases.receipt.label": "Receipt",
    "account.purchases.receipt.opening": "Opening…",
    "account.purchases.receipt.unavailable": "Receipt is not available right now.",

    // ── Account · Language ─────────────────────────────────────────────
    "account.language.heading": "Display language",
    "account.language.subheading":
      "Switch the interface language. Subtitles and every page update to match.",
    "account.language.tip": "Tip: you can also switch from the top bar on any page.",

    // ── Account · Wallet ───────────────────────────────────────────────
    "account.wallet.balance_label": "Wallet balance",
    "account.wallet.totals": "Topped up ฿{credited} · Spent ฿{spent}",
    "account.wallet.topup.heading": "Top up",
    "account.wallet.topup.subheading": "Min ฿10 · Pay by card or PromptPay",
    "account.wallet.topup.custom_placeholder": "Other amount (10–5000)",
    "account.wallet.topup.cta": "Top up",
    "account.wallet.tx.heading": "Transactions",
    "account.wallet.tx.empty": "No transactions yet.",
    "account.wallet.tx.balance_label": "balance",
    "account.wallet.tx.kind.topup": "Top up",
    "account.wallet.tx.kind.promo": "Promo credit",
    "account.wallet.tx.kind.refund": "Refund",
    "account.wallet.tx.kind.unlock_episode": "Episode unlock",
    "account.wallet.tx.kind.unlock_bundle": "Bundle unlock",
    "account.wallet.tx.kind.adjustment": "Adjustment",

    // ── Account · Watch history ────────────────────────────────────────
    "account.history.empty.title": "Nothing watched yet",
    "account.history.empty.description": "Pick a series and play the first episode.",
    "account.history.empty.cta": "Browse series",
    "account.history.continue_heading": "Continue watching",
    "account.history.all_heading": "All activity",
    "account.history.clear_link": "Clear history",
    "account.history.confirm.title": "Clear watch history?",
    "account.history.confirm.message":
      "This can't be undone — every Continue-watching item will be removed.",
    "account.history.confirm.confirm": "Clear",
    "account.history.confirm.confirm_busy": "Clearing…",
    "account.history.confirm.cancel": "Cancel",
    "account.history.status.completed": "Completed",

    // ── Account · Devices ──────────────────────────────────────────────
    "account.devices.heading": "Active devices",
    "account.devices.subheading": "Sign out of anything you don't recognize.",
    "account.devices.signout_others": "Sign out everywhere else",
    "account.devices.signout_others_busy": "Signing out…",
    "account.devices.this_device": "This device",
    "account.devices.signout": "Sign out",
    "account.devices.signout_busy": "Signing out…",
    "account.devices.signout_current": "Sign out",

    // ── Account · Security ─────────────────────────────────────────────
    "account.security.password.heading": "Change password",
    "account.security.password.subheading": "Pick a strong password you don't use anywhere else.",
    "account.security.password.current": "Current password",
    "account.security.password.new": "New password",
    "account.security.password.confirm": "Confirm new password",
    "account.security.password.too_short": "Password must be 8+ characters.",
    "account.security.password.mismatch": "Passwords do not match.",
    "account.security.password.updated": "Password updated.",
    "account.security.password.save": "Update password",
    "account.security.password.saving": "Saving…",
    "account.security.2fa.heading": "Two-factor authentication",
    "account.security.2fa.subheading":
      "Use an app like Google Authenticator for a one-time code each sign-in.",
    "account.security.2fa.status.enabled": "Enabled",
    "account.security.2fa.status.off": "Off",
    "account.security.2fa.confirm_label": "Confirm with password",
    "account.security.2fa.enable": "Enable",
    "account.security.2fa.enabling": "Enabling…",
    "account.security.2fa.disable": "Disable",
    "account.security.2fa.disabling": "Disabling…",
    "account.security.2fa.setup_heading": "Next: scan this QR or copy the secret into your app.",
    "account.security.2fa.backup_codes": "Backup codes",
    "account.security.2fa.backup_codes_hint":
      "Save these somewhere safe — they let you sign in if you lose your authenticator.",

    // ── Account · Notifications ────────────────────────────────────────
    "account.notifications.marketing.title": "Marketing emails",
    "account.notifications.marketing.desc": "Seasonal promos and new-genre launches.",
    "account.notifications.new_releases.title": "New-release alerts",
    "account.notifications.new_releases.desc":
      "Get notified when a series you follow drops a new episode.",
    "account.notifications.newsletter.title": "Weekly newsletter",
    "account.notifications.newsletter.desc": "Editor's picks, interviews, and behind-the-scenes.",
    "account.notifications.saving": "Saving…",
    "account.notifications.saved": "Saved.",
    "account.notifications.auto_save_hint": "Changes save automatically.",

    // ── Account · Data & privacy ───────────────────────────────────────
    "account.privacy.export.heading": "Export my data",
    "account.privacy.export.subheading":
      "We'll bundle your profile, watch history, and purchases and email a ZIP link within 24 hours.",
    "account.privacy.export.queued": "Request queued",
    "account.privacy.export.eta": "Expect an email within {hours} hours.",
    "account.privacy.export.busy": "Submitting…",
    "account.privacy.export.cta": "Request a copy",
    "account.privacy.delete.heading": "Delete my account",
    "account.privacy.delete.subheading":
      "Your account is locked immediately and permanently deleted after 30 days. Contact support during that window to cancel.",
    "account.privacy.delete.cta": "Delete account",
    "account.privacy.delete.confirm_title": "Confirm account deletion?",
    "account.privacy.delete.confirm_message":
      "Type {email} to confirm. This action cannot be undone.",
    "account.privacy.delete.confirm": "Delete account",
    "account.privacy.delete.deleting": "Deleting…",
    "account.privacy.delete.cancel": "Cancel",

    // ── Legal page titles ──────────────────────────────────────────────
    "legal.terms.title": "Terms of Service",
    "legal.privacy.title": "Privacy Policy",
    "legal.cookies.title": "Cookie Policy",
    "legal.refund.title": "Refund Policy",
    "legal.contact_prefix": "For legal questions, contact ",
  },
};
